import { render } from "./CartCustomer.vue?vue&type=template&id=70cdf3d0"
import script from "./CartCustomer.vue?vue&type=script&lang=js"
export * from "./CartCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__